import { ROLES, type Me, type UserRole } from "../redux/api/user.api";

/**
 * Determines if a user is authorized based on their assigned roles.
 * @param user - The user object containing role information
 * @param roles - Array of roles required for authorization
 * @returns true if the user has at least one role in the provided roles array, false otherwise
 */
export function isAuthorized(user: Me | undefined, roles: UserRole[]): boolean {
  if (!user?.roles?.length) {
    return false;
  }
  return user.roles.some((role) => roles.includes(role));
}

/**
 * Determines if the user has the Admin role.
 * @param user - The user object containing role information
 * @returns true if the user has the Admin role, false otherwise
 */
export function isAdmin(user: Me | undefined): boolean {
  return isAuthorized(user, [ROLES.ADMIN]);
}

/**
 * Determines if the user has at least basic access (User or Admin role).
 * @param user - The user object containing role information
 * @returns true if the user has User or Admin role, false otherwise
 */
export function hasUserRole(user: Me | undefined): boolean {
  return isAuthorized(user, [ROLES.USER, ROLES.ADMIN]);
}
